var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropdownArrowGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 8,
    viewBox: "0 0 16 8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(12) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path9429",
    d: "M2.917,291.965a.883.883,0,0,0-.847.556.836.836,0,0,0,.266.956l5.4,4.474-5.4,4.472a.84.84,0,0,0-.349.824.863.863,0,0,0,.6.676.9.9,0,0,0,.9-.208L9.666,298.6a.835.835,0,0,0,0-1.3L3.482,292.18a.9.9,0,0,0-.565-.215Z",
    transform: "translate(-1.976 -291.965)",
    fill: "#707070"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownArrowGrey);
export default __webpack_public_path__ + "static/media/dropdown-arrow-grey.f37b241a1ac5ad9672c3d80313ebfe3a.svg";
export { ForwardRef as ReactComponent };